import { Grid, Paper } from '@material-ui/core';
import React from 'react';
import { useSelector } from 'react-redux';
import styles from './OptionsBoardStyles';
import TickerStatsHeader from './TickerStatsHeader';
import BoardViewSection from './BoardViewSection';

const MainSection = ({ rows, changeBidAskMid }) => {
	const { appReducer } = useSelector((state) => state);

	const {
		isMobile,
		quoteInfo: { symbol },
		ticker,
	} = appReducer;


	return (
		<Grid item xs={12} md={8} lg={8} xl={8} style={{ height: '100%' }}>
			<div
				style={
					isMobile
						? styles.mobileOptionsBoardContainer
						: styles.optionsBoardContainer
				}
			>
				<Paper
					square={true}
					style={isMobile ? styles.paperContainerMobile : styles.paperContainer}
				>
					<div style={styles.visiblediv}>
						<div style={styles.flexContainer}>
							<TickerStatsHeader />
							<BoardViewSection changeBidAskMid={changeBidAskMid} rows={rows} />
						</div>
					</div>

					<div style={styles.visiblelink}>
						{ticker && symbol && (
							<div>
								{isMobile && (
									<div style={styles.findEdgeContainer}>
										Find Edge in the Unshaded Window
									</div>
								)}
								<div
									style={{
										paddingTop: '0px',
										color: 'gray',
										fontSize: '12px',
										paddingRight: '12px',
									}}
								>
									United States Patent No. 11,004,151
								</div>
							</div>
						)}
					</div>
				</Paper>
			</div>
		</Grid>
	);
};

export default MainSection;



// WEBPACK FOOTER //
// ./src/Pages/OptionsBoard/MainSection.jsx